<template>
  <div style="width: 100%" class="yxzcsr">
    <div class="tzgg">
      <div class="title">
        <span>通知公告</span>
        <router-link to="/announcement?type=0">
          <span>更多</span>
          <img src="@/assets/img/more_white.png" alt="" />
        </router-link>
      </div>
      <div class="dataList">
        <div v-for="(item, index) in list0" :key="index">
          <router-link :to="{ name: '新闻中心详情', query: { id: item.id } }">
            <span
              ><img src="../../../assets/img/arrow.png" alt="" />
              <span>{{ item.title }}</span></span
            >
            <span>[{{ item.logintime }}]</span>
          </router-link>
        </div>
      </div>
    </div>
    <div class="cjgg">
      <div class="title">
        <span>意向转出</span>
        <router-link to="/announcement?type=3">
          <span>更多</span>
          <img src="@/assets/img/more_white.png" alt="" />
        </router-link>
      </div>
      <div class="dataList">
        <div v-for="(item, index) in list3" :key="index">
          <router-link
            :to="{ name: '意向转出受让详情', query: { id: item.id } }"
          >
            <span
              ><img src="../../../assets/img/arrow.png" alt="" />
              <span>{{ item.areaName }}{{ item.projectname }}</span></span
            >
            <span>[{{ item.logintime }}]</span>
          </router-link>
        </div>
      </div>
    </div>
    <div class="jzgg">
      <div class="title">
        <span>意向受让</span>
        <router-link to="/announcement?type=4">
          <span>更多</span>
          <img src="@/assets/img/more_white.png" alt="" />
        </router-link>
      </div>
      <div class="dataList">
        <div v-for="(item, index) in list4" :key="index">
          <router-link
            :to="{ name: '意向转出受让详情', query: { id: item.id } }"
          >
            <span
              ><img src="../../../assets/img/arrow.png" alt="" />
              <span>{{ item.areaName }}{{ item.projectname }}</span></span
            >
            <span>[{{ item.logintime }}]</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getNewslist,
  publicityList,
  attest,
  desiredList,
} from '../../../api/mian'
export default {
  data () {
    return {
      dm: '',
      area_name: '',
      li_id: 0,
      list0: [],
      list1: [],
      list2: [],
      list3: [],
      list4: [],
      // list5: [

      // ],
    }
  },
  created () {
    this.dm = this.$route.query.dm
    this.area_name = this.$route.query.area_name
    console.log(this.dm)
    // 通知公告数据

    let data1 = {
      number: '004',
      pageNum: 1,
      pageSize: 7,
    }
    getNewslist(data1).then((res) => {
      this.list0 = res.data.rows
    })

    // 成交公告数据
    let data2 = {
      number: '004',
      pageNum: 1,
      pageSize: 7,
    }
    publicityList(data2).then((res) => {
      this.list1 = res.data.rows
    })

    // 鉴证公告数据
    attest({
      pageNum: 1,
      pageSize: 7,
    }).then((res) => {
      this.list2 = res.data.rows
      // console.log('鉴证公告', res)
    })

    desiredList({
      type: 1,
      pageNum: 1,
      pageSize: 7,
    }).then((res) => {
      console.log('意向转出', res)
      this.list3 = res.data.rows
    })

    desiredList({
      type: 2,
      pageNum: 1,
      pageSize: 7,
    }).then((res) => {
      console.log('意向受让', res)
      this.list4 = res.data.rows
    })
  },
  methods: {
    changeBJ (e) {
      this.li_id = e
    },
  },
}
</script>

<style scoped>
.yxzcsr {
  width: 100%;
  height: 460px;
  display: flex;
  justify-content: space-around;
}
.yxzcsr > div {
  height: 120px;
  width: 558px;
}
.yxzcsr > .tzgg {
  background: url("../../../assets/img/tzgg.png") no-repeat;
  background-size: 100% 100%;
}
.yxzcsr > .cjgg {
  background: url("../../../assets/img/cjgg.png") no-repeat;
  background-size: 100% 100%;
}
.yxzcsr > .jzgg {
  background: url("../../../assets/img/jzgg.png") no-repeat;
  background-size: 100% 100%;
}
.yxzcsr > * > .title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  padding: 0 23px 0 44px;
}
.yxzcsr > * > .title > span {
  font-family: SourceHanSans-Bold;
  font-size: 24px;
  color: #ffffff;
  text-align: center;
  font-weight: bold;
}
.yxzcsr > * > .title > a {
  display: flex;
  align-items: center;
}
.yxzcsr > * > .title > a > span {
  font-family: SourceHanSans-Regular;
  font-size: 18px;
  color: #ffffff;
  text-align: right;
  font-weight: 400;
}
.yxzcsr > * > .title > a > img {
  width: 10px;
  height: 10px;
}
.yxzcsr > * > .dataList {
  height: auto;
  width: 100%;
}
.yxzcsr > * > .dataList > div > a {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
}
.yxzcsr > * > .dataList > div:first-child > a {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  padding-top: 26px;
}
.yxzcsr > * > .dataList > div > a > span {
  font-size: 18px;
  display: flex;
  align-items: center;
}
.yxzcsr > * > .dataList > div > a > span:first-child > span {
  width: 400px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.yxzcsr > * > .dataList > div > a > span:first-child > img {
  width: 10px;
  height: 16px;
  margin-right: 10px;
}
</style>
